import "../App.css";
import logo from "../imgs/Header.png";
import placeholder from "../imgs/placeholder.jpeg";

import Navbar from "../components/navbar"
import Warning from "../components/warning";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";

import { useInView } from "react-intersection-observer";
const FadeInTitle = ({ children }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <p ref={ref} className={`fade-in Sector Concert Center Cyan ${inView ? "visible" : ""}`}>
      {children}
    </p>
  );
};


const Contact = () => {
  return (
    <div className="App">
      <Helmet>
        <title>Heartland Fun: Contact Us</title>
        <meta name="title" content="Heartland Fun: Contact Us" />
        <meta name="description" content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta name="keywords" content="Arcade equipment, Claw machines, Gaming systems, Amusement supplier, Business entertainment, Arcade experience, Hassle-free purchasing, Entertainment solutions, Fun equipment, Gaming for businesses" />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta property="og:title" content="Heartland Fun: Contact Us" />
        <meta property="og:type" content="website" />
        <meta property="og:description " content="Heartland Fun Amusement offers a variety of arcade equipment to create unforgettable experiences for your business with easy, hassle-free purchasing." />
        <meta property="og:determiner " content="" />
        <meta property="og:url" content="https://heartland.csfrederick.com/contact" />
        <meta property="og:image" content="https://heartland.csfrederick.com/Header.png" />
        <meta property="og:image:secure_url" content="https://heartland.csfrederick.com/Header.png" />
        <link rel="icon" href="/favicon.ico" />
      </Helmet>
      <Navbar></Navbar>
      <Warning></Warning>
      <FadeInTitle>
        CONTACT US
      </FadeInTitle>
      <div className="Brake"></div>
      <p className="Blue InfoText Titillium Center FadeIn">


        At our Lawrence, KS location, we take our customer service seriously. We believe that every interaction with our customers is an opportunity to make a positive impact. Whether you're looking to make a big purchase or just grabbing a single item, we're here to help. Our team of experts is always available to offer advice, answer your questions, and ensure you have the best possible experience. Don't hesitate to reach out to us at (785)813-7921 or Heartlandfun23@gmail.com, or stop by our store today!
        <br></br><br></br>
        We pride ourselves on offering competitive prices and the latest technology in the industry. And if you're in Lawrence, KS, we invite you to come check us out in person. Don't miss out on the fun - contact Heartland Fun today!
      </p>
      <a href="tel:7858137921" className="Button Titillium Center">
        Call Us
      </a>
      <br /><br />
      <a href="mailto:ziyad@heartlandfun.com" className="Button Titillium Center">
        Email Us
      </a>
      <Footer></Footer>
    </div>
  );
};

export default Contact;